module.exports = "pegasus/assets/two-column-text-second-larger-preview.png";